import { ComponentType } from '../table_component'
import { Schema } from '../types'

export const topLevelSchema: Schema = {
  title: 'Top Level Indicator',
  columns: [
    {
      id: 'no',
      name: 'No.',
      component: ComponentType.NO
    },
    {
      id: 'name',
      name: 'Statistic Name',
      component: ComponentType.Text
    },
    {
      id: 'mean',
      name: 'Mean',
      component: ComponentType.MetricStats
    },
    {
      id: 'std',
      name: 'Std',
      component: ComponentType.MetricStats
    },
    {
      id: 'location',
      name: 'Metric Location',
      component: ComponentType.Text
    }
  ]
}
